<template>
  <div>
    <v-card class="mt-4 lancar-notas-header-select">
      <v-card-text>
        <v-alert type="error" :value="msgArrayError.length > 0" dark class="mb-3">
          <div v-if="msgArrayError.length > 0">
            <ul v-for="error of msgArrayError" :key="error.key">
              <li>{{ error }}</li>
            </ul>
          </div>
        </v-alert>
        <busca-ano-turma-disciplina @chosen="chosen"></busca-ano-turma-disciplina>
        <Select
          v-show="aaletivo && cddiscipl && cdturma"
          class="pa-3"
          label="Mês"
          v-model="mes"
          :options="optionsMes"
          @change="reload"
          style="width: 50%"
        />

        <v-card class="pa-3 mt-2">
          <v-flex xs12>
            <div class="table-overflow">
              <table class="table-siged mt-3" v-if="colunas.length > 0">
                <thead class="fixed">
                  <tr>
                    <th colspan="1"></th>
                    <th :colspan="colunas.length">
                        <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }" >
                          <v-icon v-bind="attrs" v-on="on"  size="20" >notification_important</v-icon>
                        </template>
                        <span class="text-caption white--text">O registro de frequência mensal é por dia, caso haja mais de uma aula, o registro será aplicado em todas as aulas referente ao dia.<br>
                          Se o aluno estiver presente em uma aula e ausente em outra no mesmo dia, é recomendável utilizar o lançamento de frequência<br> por módulo
                          aula para este caso.</span>
                      </v-tooltip>
                      DIAS
                    </th>
                  </tr>
                  <tr>
                    <!-- 	<th style="width: 10%">Foto</th> -->
                    <th style="width: 50%;  vertical-align: middle; padding-bottom: 28px; ">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on"  size="20" >notification_important</v-icon>
                        </template>
                        <span class="text-caption white--text">Dê um duplo clique no nome do aluno abaixo para visualizar <br>informações de contato sobre o respectivo aluno.</span>
                      </v-tooltip>
                      Aluno
                    </th>
                    <th v-for="data in colunas" :key="data.id">
                      {{ data.dia }}
                      <div style="display: flex; justify-content: space-around; margin-top: 5px;" v-if="exibeCampoRemoto">
                        <span style="font-size: 10px;">Freq</span>
                        <span style="font-size: 10px; margin-left: 30px;">Pres. ou Remoto?</span>
                      </div>
                      <div style="display: flex; justify-content: space-around;">
                        <v-btn
                          icon
                          color="green"
                          @click="marcarTodos(data.dia)"
                          :disabled="loading || !data.aberto.validador"
                        >
                          <div v-if="data.aberto.validador">
                            <v-icon>playlist_add_check</v-icon>
                          </div>
                          <div v-else>
                            {{ data.aberto.descricao }}
                          </div>
                        </v-btn>

                        <v-btn
                          icon
                          color="green"
                          @click="marcarTodosRemoto(data.dia)"
                          :disabled="loading || !data.aberto.validador || habilitaMarcarTodosRemoto(data.dia) || indicamodelodeaula === 'R'"
                          v-if="exibeCampoRemoto"
                        >
                          <div v-if="data.aberto.validador">
                            <v-icon>playlist_add_check</v-icon>
                          </div>
                          <div v-else>
                            {{ data.aberto.descricao }}
                          </div>
                        </v-btn>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="enturmacao in alunos" :key="enturmacao.id">
                    <!-- <td class="centro">foto</td> -->
                    <td v-if="enturmacao.dtafastam" style="cursor: pointer; background-color:skyblue;" @dblclick="dadosContatoAluno = {dialog: true, cdtipesc: enturmacao.cdtipesc, cdescola: enturmacao.cdescola, numatalun: enturmacao.numatalun};"
                        class="column-fixed">{{ enturmacao.nmaluno }}
                    </td>
                    <td v-else style="cursor: pointer;" @dblclick="dadosContatoAluno = {dialog: true, cdtipesc: enturmacao.cdtipesc, cdescola: enturmacao.cdescola, numatalun: enturmacao.numatalun};"
                        class="column-fixed">{{ enturmacao.nmaluno }}
                    </td>                    
                    <td
                      v-for="(key, index) in colunas"
                      :key="key.id"
                      class="centro"
                    >
                      <div
                        v-if="
                          verificarDataEnturmacao(
                            enturmacao.dtsitalun,
                            enturmacao.aulas[index].dataaula
                          )
                        "
                      >
                        NÃO ESTAVA NA TURMA
                      </div>
                      <!-- <div v-else-if="verificarDataTransferencia(enturmacao.dtafastam, enturmacao.aulas[index].dataaula)">{{ enturmacao.invalido }}</div> -->
                      <div style="background-color: gold"
                        v-else-if="
                          verificarSituacao(
                            enturmacao.situacao_fim,
                            enturmacao.dtafastam,
                            enturmacao.aulas[index].dataaula
                          )
                        "
                      >
                        <span>{{ enturmacao.situacao_fim.dssitalun }}</span>
                        <span v-if="enturmacao.dtafastam">
                          - {{ enturmacao.dtafastam | formatDataBR }}</span
                        >
                      </div>
                      <div v-else-if="enturmacao.invalido && enturmacao.invalido == 'DISPENSADO'">DISPENSADO</div>
                      <div v-else class="centro" style="display: flex; justify-content: space-around;">
                        <span>
                              <CheckFrequencia
                                :disabled="
                                  loading ||
                                  verificarDataEnturmacao(
                                    enturmacao.dtsitalun,
                                    enturmacao.aulas[index].dataaula
                                  ) ||
                                  !enturmacao.aulas[index].aberto.validador
                                "
                                v-model="enturmacao.aulas[index].frequencia"
                                @click="
                                  enturmacao.aulas[index].remoto = (indicamodelodeaula === 'R' && enturmacao.aulas[index].frequencia === 'P' ) ? 'S' : (enturmacao.aulas[index].frequencia === 'A') ? '' : enturmacao.aulas[index].remoto;
                                  submit(
                                    key,
                                    enturmacao.numatalun,
                                    enturmacao.turma,
                                    enturmacao.aulas[index].frequencia,
                                    enturmacao.aulas[index].remoto
                                  )
                                "
                              />
                        </span>
                        <span v-if="exibeCampoRemoto">
                              <CheckFrequencia
                                :remoto=" (indicamodelodeaula === 'R' && enturmacao.aulas[index].frequencia === 'P' ) ? 'S' : (enturmacao.aulas[index].frequencia === 'A') ? '' : enturmacao.aulas[index].remoto "
                                :disabled=" (indicamodelodeaula === 'R') ? true :
                                  loading ||
                                  verificarDataEnturmacao(
                                    enturmacao.dtsitalun,
                                    enturmacao.aulas[index].dataaula
                                  ) ||
                                  !enturmacao.aulas[index].aberto.validador ||
                                  enturmacao.aulas[index].frequencia === null ||
                                  enturmacao.aulas[index].frequencia === 'A'
                                "
                                v-model="enturmacao.aulas[index].remoto"

                                @click="
                                  submit(
                                    key,
                                    enturmacao.numatalun,
                                    enturmacao.turma,
                                    enturmacao.aulas[index].frequencia,
                                    enturmacao.aulas[index].remoto
                                  )
                                "
                              />
                        </span>


                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <p v-else-if="aaletivo == ''"></p>
              <p v-else>Não possuem aula(s) cadastradas para esse mês.</p>
            </div>
          </v-flex>
        </v-card>
      </v-card-text>
    </v-card>
    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>

    <ContatoAluno v-bind.sync="dadosContatoAluno" />

  </div>
</template>

<script>
import ContatoAluno from '@/components/ContatoAluno';
import BuscaAnoTurmaDisciplina from "@/components/BuscaAnoTurmaDisciplina";
// import BuscaAnoNivelEtapa from "@/components/BuscaAnoNivelEtapa";
import store from "@/store/index";
import CheckFrequencia from "@/components/CheckFrequencia";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
// import udias from "@/utils/dias";
import moment from "moment";
import _ from "lodash";
// import { ehTurmaAEEouACP } from '@/utils/turmas'

moment.locale("pt-br");

const dadosUser = () => ({
  ...store.getters.userProfessor,
  ...store.getters.school,
});

const DiarioEscolarRepository = RepositoryFactory.get("diarioEscolar");

const defaultSelect = () => ({
  text: "",
  value: "",
});

export default {
  name: "FrequenciaMensal",
  components: {
    CheckFrequencia,
    BuscaAnoTurmaDisciplina,
    ContatoAluno,
  },
  data() {
    return {
      rangePeriodoAnoLetivo: {},
      aaletivo: "",
      cdturma: "",
      cddiscipl: "",
      mes: moment().format("YYYY-MM"),
      dados: [],
      frequencia: [],
      submitText: "",
      snackbar: false,
      loading: false,
      inv: false,
      optionsMes: null,
      msgArrayError: [],
      dadosContatoAluno: {},
      exibeCampoRemoto: false,
      indicamodelodeaula: '',
      dadosTurma: [],
    };
  },

  mounted() {
    this.$Progress.finish();
  },
  methods: {
    async getRangePeriodoAnoLetivo(aaletivo, cdinstruc) {
      const params = {
        aaletivo,
        cdinstruc,
      };

      const { data } = await DiarioEscolarRepository.getRangePeriodoAnoLetivo(
        params
      );

      this.rangePeriodoAnoLetivo = data;
    },
    async chosen(data) {
        (this.aaletivo = data.aaletivo),
        (this.cddiscipl = data.cddiscipl),
        (this.cdturma = data.cdturma),


      await this.getRangePeriodoAnoLetivo(this.aaletivo, data.cdinstruc);
      await this.meses();
      await this.reload();
      //console.log(data);
    },
    async reload() {
      this.$Progress.start();
      const { data } = await DiarioEscolarRepository.getListarAulasMes({
        ...dadosUser(),
        mes: this.mes,
        aaletivo: this.aaletivo,
        cddiscipl: this.cddiscipl,
        cdturma: this.cdturma,
      });

       this.exibeCampoRemoto = (data.configuracaoAnoLetivo.indicamodelodeaula === 'P') ? false : true;
       this.indicamodelodeaula = data.configuracaoAnoLetivo.indicamodelodeaula;

      this.dados = data.results;
      this.dadosTurma = this.dados.map(e => e.turma)[0]
      this.msgArrayError = [];

      this.$Progress.finish();
    },
    habilitaMarcarTodosRemoto(dia) {
      let frequencias = this.alunos.filter(
                                    element =>{
                                      element.invalido === null && parseInt(element.dtsitalun.slice(-2)) >= dia
                                      }
                               )
                                .map(
                                 element => element.aulas.filter(
                                                                element => element.dia === dia
                                                             ).
                                                             map(
                                                               e => e.frequencia !== null
                                                             )
                              );
      frequencias = frequencias.flat();
      return frequencias.some(element => element === false);
    },
    async submit(aulas, numatalun, turma, frequencia, remoto) {
      try {
        this.$Progress.start();
        this.loading = true;

        if(frequencia === 'A') {
          remoto = '';
        }

        const formulario = {
          identificadoraula: aulas.codigoaulas,
          cdtipesc: turma.cdtipesc,
          cdescola: turma.cdescola,
          aaletivo: turma.aaletivo,
					cdinstruc: turma.cdinstruc,
          alunos: [
            {
              numatalun: numatalun,
              indicapresenca: frequencia,
              indicaalunoremoto: remoto
            },
          ],
        };

        const { data } = await DiarioEscolarRepository.setFrequancia(
          formulario
        );

        this.submitText = data.message;
        this.snackbar = true;
      } finally {
        this.$Progress.finish();
        this.loading = false;

        this.msgArrayError = [];
      }
    },
    meses() {
      const inicio = moment(this.rangePeriodoAnoLetivo.inicio);
      const fim = moment(this.rangePeriodoAnoLetivo.fim);

      const months = fim.diff(inicio, "months");

      let currentDate = inicio;
      const dates = [
        { value: moment(inicio).format("YYYY-MM"), text: moment(inicio).format("MMMM")},
        ...Array(months)
          .fill(1)
          .map((item) => {
            let text;
            const value = moment(currentDate).add(1, "M").format("YYYY-MM");
            if (this.rangePeriodoAnoLetivo.indicaanoletivoexcedeu === "S") {
              text = `${moment(currentDate)
                .add(1, "M")
                .format("MMMM")} - ${moment(currentDate)
                .add(1, "M")
                .format("YYYY")}`;
            } else {
              text = `${moment(currentDate).add(1, "M").format("MMMM")}`;
            }
            currentDate = value;
            return { value, text };
          }),
      ];

      // console.log("dates", dates);

      this.optionsMes = dates;

      // const meses = [
      //   { value: "2020-01", text: "Janeiro -  2020" },
      //   { value: "2020-02", text: "Feveiro -  2020" },
      //   { value: "2020-03", text: "Março -  2020" },
      //   { value: "2020-04", text: "Abril -  2020" },
      //   { value: "2020-05", text: "Mail -  2020" },
      //   { value: "2020-06", text: "Junho -  2020" },
      //   { value: "2020-07", text: "Julho -  2020" },
      //   { value: "2020-08", text: "Agosto -  2020" },
      //   { value: "2020-09", text: "Setembro -  2020" },
      //   { value: "2020-10", text: "Outubro -  2020" },
      //   { value: "2020-11", text: "Novembro -  2020" },
      //   { value: "2020-12", text: "Dezembro -  2020" },
      //   { value: "2021-01", text: "Janeiro -  2021" },
      //   { value: "2021-02", text: "Fevereiro -  2021" },
      //   { value: "2021-03", text: "Março -  2021" },
      // ];

      // this.optionsMes = _.remove(meses, function (n) {
      //   return n.value;
      // });

      // console.log("optionsMes", this.optionsMes);
    },
    //      meses(){
    //   var meses = udias.meses.map((v, i) => ({
    //     value: i + 1,
    //     text: v,
    //   }));

    //   this.optionsMes =  _.remove(meses, function(n){
    //     //return n.value <= moment().format('M'); -- Essa linha foi comentada pois houve problema na exibição do campo mês. Em 2020, exibiu apenas Janeiro sendo que a professora queria lançar dados de 2019
    //     return n.value ;
    //   }

    //   );

    // },
    verificarDataEnturmacao(dataEnturmacao, dataaula) {
      return dataEnturmacao > dataaula;
    },
    verificarDataTransferencia(dtafastam, dataaula) {
      return dtafastam >= dataaula;
    },
    verificarSituacao(situacao, dataSituacao, dataaula) {
      if (typeof situacao === "undefined" || situacao === null) {
        return false;
      }
      if (parseInt(situacao.cdsitalun) >= 0) {
        if (dataaula < dataSituacao) {
          return false;
        }
        return true;
      }
      return false;
    },
    async marcarTodos(dia) {
      try {
        this.$Progress.start();
        this.loading = true;
        const formulario = {
          identificadoraula: [],
          cdtipesc: "",
          cdescola: "",
          aaletivo: 0,
          alunos: [],
        };
        this.dados = this.dados.map((key) => {
          //if(!(key.invalido)) {
          for (const index in key.aulas) {
            if (
              key.aulas[index].dia == dia &&
              !this.verificarDataEnturmacao(
                key.dtsitalun,
                key.aulas[index].dataaula
              ) &&
              !this.verificarSituacao(
                key.situacao_fim,
                key.dtafastam,
                key.aulas[index].dataaula
              )
            ) {
              key.aulas[index].frequencia = "P";
              let aluno = this.alunos.find(element => element.nuidaluno === key.nuidaluno);
             // key.aulas[index].remoto = (this.indicamodelodeaula === 'R' && key.aulas[index].frequencia === "P" ) ? 'S' : aluno.aulas[index].remoto;
             if (this.indicamodelodeaula === 'R' && key.aulas[index].frequencia === 'P') {
                key.aulas[index].remoto = 'S';
              }
              else if (this.indicamodelodeaula === 'H' && key.aulas[index].frequencia === 'P') {
                key.aulas[index].remoto = 'S';
              }
              else {
                key.aulas[index].remoto = 'N';
              }

              formulario.identificadoraula = key.aulas[index].codigoaulas;
              formulario.cdtipesc = key.turma.cdtipesc;
              formulario.cdescola = key.turma.cdescola;
              formulario.aaletivo = key.turma.aaletivo;
              formulario.alunos.push({
                numatalun: key.numatalun,
                indicapresenca: "P",
                indicaalunoremoto: key.aulas[index].remoto
              });
            }
          }
          //}
          return key;
        });

        if (formulario.alunos.length > 0) {
          const { data } = await DiarioEscolarRepository.setFrequancia(
            formulario
          );
          this.submitText = data.message;
          this.snackbar = true;
          this.msgArrayError = [];
        } else {
          this.msgArrayError.push("Nenhum Aluno Disponível");
          //console.log(this.msgArrayError);
        }
      } finally {
        this.$Progress.finish();
        this.loading = false;
      }
    },
    async marcarTodosRemoto(dia) {
      try {
        this.$Progress.start();
        this.loading = true;
        const formulario = {
          identificadoraula: [],
          cdtipesc: "",
          cdescola: "",
          aaletivo: 0,
          alunos: [],
        };
        this.dados = this.dados.map((key) => {
          //if(!(key.invalido)) {
          for (const index in key.aulas) {
            if (
              key.aulas[index].dia == dia &&
              !this.verificarDataEnturmacao(
                key.dtsitalun,
                key.aulas[index].dataaula
              ) &&
              !this.verificarSituacao(
                key.situacao_fim,
                key.dtafastam,
                key.aulas[index].dataaula
              )
            ) {
              // key.aulas[index].remoto = (this.indicamodelodeaula === 'R' && key.aulas[index].indicapresenca === 'P') ? 'S' : 'N';
              if (this.indicamodelodeaula === 'R' && key.aulas[index].indicapresenca === 'P') {
                key.aulas[index].remoto = 'S';
              }
              else if (this.indicamodelodeaula === 'H' && key.aulas[index].indicapresenca === 'P') {
                key.aulas[index].remoto = 'N';
              }
              else {
                key.aulas[index].remoto = 'N';
              }
              let aluno = this.alunos.find(element => element.nuidaluno === key.nuidaluno);
              key.aulas[index].indicapresenca = aluno.aulas[index].frequencia;

              formulario.identificadoraula = key.aulas[index].codigoaulas;
              formulario.cdtipesc = key.turma.cdtipesc;
              formulario.cdescola = key.turma.cdescola;
              formulario.aaletivo = key.turma.aaletivo;
              formulario.alunos.push({
                numatalun: key.numatalun,
                indicaalunoremoto: key.aulas[index].remoto,
                indicapresenca: key.aulas[index].indicapresenca
              });
            }
          }
          //}
          return key;
        });
        if (formulario.alunos.length > 0) {
          const { data } = await DiarioEscolarRepository.setFrequancia(
            formulario
          );
          this.submitText = data.message;
          this.snackbar = true;
          this.msgArrayError = [];
        } else {
          this.msgArrayError.push("Nenhum Aluno Disponível");
          //console.log(this.msgArrayError);
        }
      }
      finally {
        this.$Progress.finish();
        this.loading = false;
      }
    },
  },
  computed: {
    colunas() {
      if (this.dados.length > 0) return this.dados[0].aulas;
      else return 0;
    },
    alunos() {
      return this.dados;
    },
    // AEEouACP() {
    //   return ehTurmaAEEouACP(this.dadosTurma.cdtpatend, this.dadosTurma.cdinstruc, this.dadosTurma.cdserie)
    // }
  },
};
</script>

<style lang="scss" scoped>
.table-overflow {
  overflow-y: auto;
  position: relative;
  max-height: 565px;

  &::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.14);
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
  }

  .fixed {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 4;

    th {
      position: -webkit-sticky;
      position: sticky;
      top: -1px;
      z-index: 4;
      background: white;
    }

    .header-detalhado {
      top: 67px !important;
    }
  }

  .column-fixed {
    position: -webkit-sticky;
    position: sticky;
    left: 0;
    z-index: 3;
    // background: white;
  }
}
</style>
